import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Typography,
  message,
  Spin
} from "antd";
import { RightOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../../pageHeader/LeftLayout";
import { routes } from "../../../routes/Routes";
import { COMMON_ERROR_MSG, SESSION_TOKEN } from "../../../constants/constants";
import IntegerInput from "../../../components/IntergerInput";
import _capitalProviderService from "../../../modules/capitalProviderService";


import HeaderComponentWithTitleAndLogo from "../../../components/HeaderComponentWithTitleAndLogo/HeaderComponentWithTitleAndLogo";
import MainLayout from "../../../components/MainLayout/MainLayout";
import VerifyOtp from "../../../components/VerifyOtp/VerifyOtp";

const { Title, Text, Link } = Typography;

const CapitalProviderVerifyOTP = () => {
  const history = useHistory();
  const [timer, setTimer] = useState(120);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  // let data = location.state;
  // let emailId = "";
  // if (data && data.email) {
  //   emailId = data.email;
  // }

  // const [email] = useState(emailId);

  const getQueryParams = () => {
    return new URLSearchParams(location.search);
  };

  const query = getQueryParams();
  const emailID = query.get('email');

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((t) => t - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);


  // const onBack = () => {
  //   history.push(routes.createCapitalProviderAccount.path);
  // };

  const onFinish = async (values) => {
    const reqObj = {
      Email: emailID,
      EmailOTP: values.otp
    }
    setLoading(true);
    try {
      const res = await _capitalProviderService.confirmLoanOfficerEmailOTP(reqObj);
      if (res?.data?.IsSuccess) {
        message.success(res.data.Message);
        localStorage.setItem("capitalProviderLoginEmail", res?.data?.Obj?.Email);
        localStorage.setItem("capitalProviderUserId", res?.data?.Obj?.Id);
        localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
        localStorage.setItem("userRole", res?.data?.Obj?.Role);
        localStorage.setItem("IsCapitalProviderFlag", JSON.stringify(true));
        history.push({
          pathname: routes.createCapitalProviderLoginPassword.path,
          state: { emailID }
        }
        );
      } else {
        message.error(res.data.Message || COMMON_ERROR_MSG)
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err)
    }
  };

  const handleResendOtp = async () => {
    const reqObj = {
      Email: emailID
    }
    setLoading(true);
    try {
      const res = await _capitalProviderService.sendLoanOfficerVerifyEmailOTP(reqObj);
      if (res?.data.IsSuccess) {
        message.success(res.data.Message);
        setTimer(120); // Reset timer to 30 seconds
        setLoading(false);
      } else {
        setLoading(false);
        message.error(res.data.Message);
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }
  return (
    <Spin spinning={loading}>

      <MainLayout>
        <HeaderComponentWithTitleAndLogo
          logoSrc="/websiteLogo.png"
          logoAlt="Leveridge Logo"
          title="Capital Provider Portal - Verify Your Email"
        />
        <VerifyOtp
          email={emailID}
          timer={timer}
          onFinish={onFinish}
          onBack={() => history.push(routes.capitalProviderLogin.path)}
          handleResendOtp={handleResendOtp}
        />
      </MainLayout>

      {/* <LeftLayout>
        <div className="w450">
          <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3", marginBottom: 60 }}>
            Capital Provider Portal
          </Title>

          <Title level={4} style={{ marginBottom: 12 }}>
            Verify Your Email
          </Title>

          <Text type="secondary" style={{ display: "block", marginBottom: 24 }}>
            A six digit OTP was sent to <Text strong>{emailID}</Text>
          </Text>

          <Form layout="vertical" onFinish={onFinish} requiredMark={true}>
            <Form.Item
              label="Enter OTP"
              name="otp"
              rules={[{ required: true, message: "OTP is required" },
              {
                pattern: /^\d{6}$/,
                message: "OTP must be a 6-digit number",
              },
              ]}
            >
              <IntegerInput
                maxLength={6}
                placeholder="Enter 6-digit OTP"
                autoComplete="one-time-code"
              />
            </Form.Item>

            <Form.Item>
              <div style={{ display: "flex", gap: 16, marginTop: 20 }}>
            
                <Button
                  type="primary"
                  htmlType="submit"
                >
                  Confirm OTP <RightOutlined />
                </Button>
              </div>
            </Form.Item>
          </Form>

          <Text type="secondary" style={{ display: "block" }} className="mb-10">
            Please wait 120 seconds before resending a new OTP:{" "}
            <span style={{ fontWeight: "bold" }}>
              00:{timer.toString().padStart(2, "0")}
            </span>
          </Text>

          <div className="mt20 spaceFlex">
            <div>
              <Button shape="round" disabled={timer > 0} onClick={handleResendOtp}>Resend OTP</Button>
            </div>
            <div>
              <Link
                onClick={() => history.push(routes.capitalProviderLogin.path)}
                style={{ fontWeight: "bold", fontSize: 14 }}
              >
                Already Have An Account?  <RightOutlined />
              </Link>
            </div>
          </div>
        </div>
      </LeftLayout> */}
    </Spin>
  );
};

export default CapitalProviderVerifyOTP;